import { render, staticRenderFns } from "./user_difference.vue?vue&type=template&id=7c2233f4&"
import script from "./user_difference.vue?vue&type=script&lang=js&"
export * from "./user_difference.vue?vue&type=script&lang=js&"
import style0 from "./user_difference.vue?vue&type=style&index=0&id=7c2233f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports